import { SupportedWeaveTheme } from '@adsk/alloy-react-styles';

import fileUploadDarkBlue from './svg/empty-state-file-upload-dark-blue.svg';
import fileUploadDarkGray from './svg/empty-state-file-upload-dark-gray.svg';
import fileUploadLightGray from './svg/empty-state-file-upload-light-gray.svg';
import firstUseDarkBlue from './svg/empty-state-first-use-dark-blue.svg';
import firstUseDarkGray from './svg/empty-state-first-use-dark-gray.svg';
import firstUseLightGray from './svg/empty-state-first-use-light-gray.svg';
import noChartDataDarkBlue from './svg/empty-state-no-chart-data-dark-blue.svg';
import noChartDataDarkGray from './svg/empty-state-no-chart-data-dark-gray.svg';
import noChartDataLightGray from './svg/empty-state-no-chart-data-light-gray.svg';
import noDataDarkBlue from './svg/empty-state-no-data-dark-blue.svg';
import noDataDarkGray from './svg/empty-state-no-data-dark-gray.svg';
import noDataLightGray from './svg/empty-state-no-data-light-gray.svg';
import noPermissionDarkBlue from './svg/empty-state-no-permission-dark-blue.svg';
import noPermissionDarkGray from './svg/empty-state-no-permission-dark-gray.svg';
import noPermissionLightGray from './svg/empty-state-no-permission-light-gray.svg';
import noResultsDarkBlue from './svg/empty-state-no-results-dark-blue.svg';
import noResultsDarkGray from './svg/empty-state-no-results-dark-gray.svg';
import noResultsLightGray from './svg/empty-state-no-results-light-gray.svg';
import systemErrorDarkBlue from './svg/empty-state-system-error-dark-blue.svg';
import systemErrorDarkGray from './svg/empty-state-system-error-dark-gray.svg';
import systemErrorLightGray from './svg/empty-state-system-error-light-gray.svg';
import undergoingDarkBlue from './svg/empty-state-undergoing-dark-blue.svg';
import undergoingDarkGray from './svg/empty-state-undergoing-dark-gray.svg';
import undergoingLightGray from './svg/empty-state-undergoing-light-gray.svg';

const firstUse: Record<SupportedWeaveTheme, string> = {
  'dark-blue': firstUseDarkBlue,
  'dark-gray': firstUseDarkGray,
  'light-gray': firstUseLightGray,
};

const noChartData: Record<SupportedWeaveTheme, string> = {
  'dark-blue': noChartDataDarkBlue,
  'dark-gray': noChartDataDarkGray,
  'light-gray': noChartDataLightGray,
};

const noData: Record<SupportedWeaveTheme, string> = {
  'dark-blue': noDataDarkBlue,
  'dark-gray': noDataDarkGray,
  'light-gray': noDataLightGray,
};

const noPermission: Record<SupportedWeaveTheme, string> = {
  'dark-blue': noPermissionDarkBlue,
  'dark-gray': noPermissionDarkGray,
  'light-gray': noPermissionLightGray,
};

const noResults: Record<SupportedWeaveTheme, string> = {
  'dark-blue': noResultsDarkBlue,
  'dark-gray': noResultsDarkGray,
  'light-gray': noResultsLightGray,
};

const systemError: Record<SupportedWeaveTheme, string> = {
  'dark-blue': systemErrorDarkBlue,
  'dark-gray': systemErrorDarkGray,
  'light-gray': systemErrorLightGray,
};

const fileUpload: Record<SupportedWeaveTheme, string> = {
  'dark-blue': fileUploadDarkBlue,
  'dark-gray': fileUploadDarkGray,
  'light-gray': fileUploadLightGray,
};

const undergoing: Record<SupportedWeaveTheme, string> = {
  'dark-blue': undergoingDarkBlue,
  'dark-gray': undergoingDarkGray,
  'light-gray': undergoingLightGray,
};

export default {
  firstUse,
  noChartData,
  noData,
  noPermission,
  noResults,
  systemError,
  fileUpload,
  undergoingMaintenance: undergoing,
};
